import { Card, getCardPoints } from '../utils/CardUtils';
import { Meld, isBurraco, isCleanBurraco } from './Meld';
import {
  CLEAN_BURRACO_BONUS,
  DIRTY_BURRACO_BONUS,
  GOING_OUT_BONUS,
  NO_POZZETTO_PENALTY,
} from '../utils/Constants';

export interface RoundScore {
  meldPoints: number;
  handPenalty: number;
  burracoBonus: number;
  goingOutBonus: number;
  pozzettoPenalty: number;
  total: number;
}

export function calculateRoundScore(
  melds: Meld[],
  handCards: Card[],
  wentOut: boolean,
  tookPozzetto: boolean,
): RoundScore {
  // Sum card values in melds
  let meldPoints = 0;
  for (const meld of melds) {
    for (const card of meld.cards) {
      meldPoints += getCardPoints(card);
    }
  }

  // Subtract hand card values
  let handPenalty = 0;
  for (const card of handCards) {
    handPenalty += getCardPoints(card);
  }

  // Burraco bonuses
  let burracoBonus = 0;
  for (const meld of melds) {
    if (isBurraco(meld)) {
      burracoBonus += isCleanBurraco(meld) ? CLEAN_BURRACO_BONUS : DIRTY_BURRACO_BONUS;
    }
  }

  const goingOutBonus = wentOut ? GOING_OUT_BONUS : 0;
  const pozzettoPenalty = tookPozzetto ? 0 : NO_POZZETTO_PENALTY;

  const total = meldPoints - handPenalty + burracoBonus + goingOutBonus + pozzettoPenalty;

  return {
    meldPoints,
    handPenalty,
    burracoBonus,
    goingOutBonus,
    pozzettoPenalty,
    total,
  };
}
